import React from "react";
import SvgIcon from "e100-react-components/lib/components/SvgIcon";
import { IProps } from "e100-react-components/lib/components/SvgIcon/index";

export const Trailer = (props: IProps) => (
  <SvgIcon {...props}>
    <path
      xmlns="http://www.w3.org/2000/svg"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1 16V18H7C7 19.6569 8.34315 21 10 21C11.6569 21 13 19.6569 13 18H14C14 19.6569 15.3431 21 17 21C18.6569 21 20 19.6569 20 18H21C22.1046 18 23 17.1046 23 16V5C23 3.89543 22.1046 3 21 3H4V5H21V16H19.2361C18.6868 15.3863 17.8885 15 17 15C16.1115 15 15.3132 15.3863 14.7639 16H12.2361C11.6868 15.3863 10.8885 15 10 15C9.1115 15 8.31321 15.3863 7.76389 16H4H3H1ZM11.5 18C11.5 18.8284 10.8284 19.5 10 19.5C9.17157 19.5 8.5 18.8284 8.5 18C8.5 17.1716 9.17157 16.5 10 16.5C10.8284 16.5 11.5 17.1716 11.5 18ZM18.5 18C18.5 18.8284 17.8284 19.5 17 19.5C16.1716 19.5 15.5 18.8284 15.5 18C15.5 17.1716 16.1716 16.5 17 16.5C17.8284 16.5 18.5 17.1716 18.5 18ZM4 7V14H6V7H4ZM10 7V14H12V7H10ZM16 7V14H18V7H16Z"
    />
  </SvgIcon>
);
